import productGroupFields from "./productGroupFields";

const footerCtaLinkFields = `
    "refTitle": footerOptions.link.document->title,
    "type": footerOptions.link.document->_type,
    "link": footerOptions.link.link,
    "handle": footerOptions.link.document->store.slug.current,
    "slug": footerOptions.link.document->slug,
    "productGroup": *[_type=="productPage" && references(^.footerOptions.link.document->_id) ] {
        ${productGroupFields}
    },
`;

export default footerCtaLinkFields;
